module.exports = __webpack_public_path__ + "img/51.d456d2c2.jpg";